import { isMacOs } from '../../../helpers/device';
import type { HotKeyConstant } from '../constants';

/**
 * Преобразует комбинацию клавиш в кроссплатформенный формат
 * На Mac: ctrl -> cmd, на Windows/Linux: остается ctrl
 */
export const getCrossPlatformKey = (key: string): string => {
    const isMac = isMacOs();

    if (isMac) {
        // На Mac заменяем ctrl на cmd
        return key.replace(/ctrl\+/g, 'cmd+');
    }

    // На Windows/Linux оставляем как есть
    return key;
};

/**
 * Преобразует массив комбинаций клавиш в кроссплатформенный формат
 */
export const getCrossPlatformKeys = (keys: HotKeyConstant): string[] => {
    if (Array.isArray(keys)) {
        return keys.map(getCrossPlatformKey);
    }

    return [getCrossPlatformKey(keys)];
};
